<template>
    <div>
        <b-row v-if="!productSelected">
            <b-col>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group>
                            <label for="search" class="d-block">
                                Buscar Producto <span class="text-danger">*</span>
                            </label>
                            <b-form-input
                                placeholder="Nombre del producto"
                                v-model="filters.search"
                                name="search"
                                id="search"
                                v-on:input="searchProductsByName()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group label="Fabricante">
                            <el-select
                                id="manufacturer_id"
                                name="manufacturer_id"
                                v-model="filters.manufacturer_id"
                                filterable
                                remote
                                clearable
                                no-data-text="No hay datos que coincidan"
                                no-match-text="No hay datos que coincidan"
                                :remote-method="obtenerFabricantesFiltro"
                                >
                            <el-option v-for="fabricante in fabricantes_filtro" :key="fabricante.id" :label="fabricante.nombre"
                                :value="fabricante.id" />
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-button variant="primary" class="column-end" @click="searchProducts()" :disabled="disableSearch">
                            <i class="fa fa-magnifying-glass text-white fa-lg mr-1"/>Buscar
                        </b-button>
                    </b-col>
                    <!--b-col md="3" lg="3" sm="12">
                        <b-button variant="primary" @click="assingProduct()" class="column-end">
                            <i class="fa fa-save text-white fa-lg mr-1"/> Asignar producto
                        </b-button>
                    </b-col-->
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <b-table class="b-table-asigns-m height-table-pr" style="font-size: 10pt;" responsive striped hover :items="products"
                        :fields="columns" thead-tr-class="table-active">
                        <template v-slot:cell(actions)="data">
                            <b-button variant="primary" @click="showProductInfo(data.item.id)">
                                <i class="fa fa-eye text-white fa-lg mr-1"/> Ver producto
                            </b-button>
                        </template>
                        </b-table>
                        <el-pagination class="float-right" v-model="paginate.page" @size-change="setPerPagePagination"
                            @current-change="setPagePagination" :current-page="paginate.page" :page-sizes="paginate.limits"
                            :page-size="paginate.per_page" layout="total,sizes, prev, pager, next" :total="paginate.total"
                        />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <b-row v-if="productSelected">
            <b-col lg="12">
                <b-button variant="primary" class="mr-2" @click="assingProductCompany">
                    <i class="fa fa-save text-white fa-lg mr-1"/>
                    <span class="d-none d-md-inline-block">Asignar producto</span>
                </b-button>
                <b-button @click="setProductSelected(null)">
                    <i class="fa fa-reply fa-lg mr-1"></i>
                    <span class="d-none d-md-inline-block"> Volver</span>
                </b-button>
            </b-col>
            <b-col lg="12">
                <productDetail :product="productSelected" ></productDetail>
            </b-col>
        </b-row>

    </div>
</template>

<script>

/* Generales */
import { mapState, mapActions, mapMutations } from 'vuex';
import SistemasClasificacion from '../sistemasclasificacion/tabs.vue';
import productDetail from './productDetail.vue';
import Epps from '../Epp.vue';

export default {
  name: "SearchProducts",
  data() {
    return {
        tabIndex: 0,
        productId: null,
        disabledInputs: true,
        columns: [
          {
            key: "nombre",
            label: "Nombre",
            sortable: true,
            thStyle: {
              "min-width": "150px !important",
            },
          },
          {
            key: "sinonimos",
            label: "Sinónimos",
            sortable: true,
            thStyle: {
              "min-width": "150px !important",
            },
          },
          {
            key: "fabricante.nombre",
            label: "Fabricante",
            sortable: true,
            thStyle: {
              "min-width": "150px !important",
              width: "150px !important",
            },
          },
          {
            key: "actions",
            label: "Opciones",
            tdClass: "text-nowrap",
            thStyle: {
              "min-width": "80px !important",
              width: "80px !important",
            },
          },
        ],
        disableSearch: true
    };
  },
  components: {
        SistemasClasificacion,
        productDetail,
        Epps,
  },
  async created() {
    this.setSelectedProduct(null);
  },
  methods: {
    async changeProduct(){
        await this.getProductById(this.productId).then(()=>{
            this.cargarInfoProducto(this.selectedProduct);
        });
        await this.getEppEmpresa();
        await this.getProductosEmpresa();
        this.setTabActivoSga(1);
    },

    async assingProductCompany(){
        let payload = {
            id_producto: this.selectedProduct.id,
            id_empresa: this.selected_empresa.id,

        };
        await this.assingProductByCompany(payload).then(()=>{
            this.setSelectedProduct(this.selectedProduct);
        });
    },

    async showProductInfo(productId){
        await this.getProductById(productId).then(()=>{
            this.setProductSelected(this.selectedProduct);
        });
    },
    searchProductsByName(){
        if(this.filters.search.length > 2)this.disableSearch = false;
    },
    ...mapActions('assignment', [
        'getProductsToAssign',
        'searchProducts',
        'assingProduct',
        'setPagePagination',
        'setPerPagePagination',
        'resetStates'
    ]),

    ...mapActions('productos', [
        'searchProdustToAssign',
        'getProductById',
        'getProductosEmpresa',
        'obtenerFabricantesFiltro'
    ]),
    ...mapActions('epps', [
        'getEppEmpresa',
    ]),
    ...mapActions('asignacionproductos', [
        'assingProductByCompany',
    ]),
    ...mapMutations('asignacionproductos', [
        'setSelectedProduct',
        'cargarInfoProducto'
    ]),
    ...mapMutations('sga', ['setTabActivoSga']),
    ...mapMutations('assignment', ['setProductSelected']),
  },
  computed: {
    ...mapState("productos", ["productsToAssing",'selectedProduct','fabricantes_filtro',]),
    ...mapState('asignacionproductos', ['productSelectedToAssing','selected_empresa']),
    ...mapState('autenticacion', [
        'usuarioAdmin',
        'usuarioEmpresa',
        'usuarioEmpresaHSE',
        'usuarioEmpresaContratista',
    ]),
    ...mapState('assignment', [
        'products',
        'paginate',
        'filters',
        'manufacturers',
        'productSelected'
    ]),
  },
  destroyed() {
      this.resetStates();
  }
}
</script>

<style scoped>
.column-end{
    margin-top: 25px;
}
</style>
